export default __webpack_public_path__ + "static/media/italy4.74f72344.png";